import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import CrossIcon from "../../../icons/cross.icon";
import styles from "./save-view-modal.scss";

const SaveViewModal = ({ show, hideModal = () => {} }) => {
  const [nameValue, setNameValue] = useState("");

  return (
    <Modal
      show={show}
      size="lg"
      dialogClassName="save-view-modal"
      className={`save-view-modal ${styles.saveViewModal}`}
      aria-labelledby="save-view-modal"
      centered
      onHide={() => hideModal()}
    >
        <Modal.Header className="text-center">
          <div className={`w-100 mb-0 ${styles.headerTitle}`}>Save View</div>
          <span className={`cursor-pointer ${styles.closeButton}`} onClick={hideModal}>
            <CrossIcon width="10px" className="pointer" fill="#616778" />
          </span>
        </Modal.Header>
      <Modal.Body className="modalContent">
        <div className={styles.contentContainer}>
          <p className={styles.description}>
            This view will include the filters and columns that are currently
            applied.
          </p>

          <div className={styles.formContainer}>
            <label
              htmlFor="name-input"
              className={styles.label}
            >
              Name
            </label>

            <div className={`${styles.inputWrapper} save-view-input-wrapper`}>
              <div className={styles.inputInnerWrapper}>
                <input
                  id="name-input"
                  type="text"
                  value={nameValue}
                  onChange={(e) => setNameValue(e.target.value)}
                  placeholder='e.g., "Referrals Expiring soon"'
                  className={styles.saveNameInput}
                  aria-label="Name"
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="cancelButton" onClick={hideModal}>
          Cancel
        </button>
        <button className="saveButton" onClick={() => {
          // Handle save logic here
          console.log('Saving view:', nameValue);
          hideModal();
        }}>
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveViewModal;
